import { FormControl, FormField, FormItem, FormMessage, Textarea } from '@packages/ui';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import zod from 'zod';
import { Step } from './Step';
import { useTranslation } from 'react-i18next';

const formSchema = zod.object({
  relationship: zod.string().min(2).max(300),
});

type FormData = zod.infer<typeof formSchema>;

type Props = {
  defaultData?: FormData;
  onSubmit: (data: FormData) => void;
  isActive: boolean;
  isDone: boolean;
  onActivate: () => void;
};
export const StepRelationship = ({
  onSubmit,
  defaultData,
  isActive,
  isDone,
  onActivate,
}: Props) => {
  const form = useForm({
    defaultValues: defaultData,
    resolver: zodResolver(formSchema),
  });

  const { t } = useTranslation();

  return (
    <Step
      question={t('wedding.relationshipQuestion')}
      form={form}
      onNext={onSubmit}
      isActive={isActive}
      isDone={isDone}
      onActivate={onActivate}>
      <FormField
        control={form.control}
        name="relationship"
        render={({ field }) => {
          return (
            <FormItem>
              <FormControl>
                <Textarea
                  placeholder={t('wedding.relationshipPlaceholder')}
                  disabled={!isActive}
                  className="w-full"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          );
        }}
      />
    </Step>
  );
};
